var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import isPropValid from '@emotion/is-prop-valid';
import theme from './theme';
import { themeGet } from 'styled-system';
export var getThemeValue = function (key) { return themeGet(key)({ theme: theme }); };
export var breakpoint = function (value) { return function (props) { return "\n  @media (min-width: " + (typeof value !== 'string' ? props.theme.breakpoints[value] : value) + ")\n"; }; };
export var fontSize = function (value) { return function (props) {
    return "font-size: " + props.theme.fontSizes[value] + "px";
}; };
var MAGIC_LINE_HEIGHT_COEFFICIENT = 1.25;
export var font = function (size, height) {
    if (size === void 0) { size = 0; }
    if (height === void 0) { height = -1; }
    return function (props) {
        height =
            height === -1
                ? props.theme.space.findIndex(function (spacing) {
                    return spacing >=
                        props.theme.fontSizes[size] * MAGIC_LINE_HEIGHT_COEFFICIENT;
                })
                : height;
        return "\n    " + fontSize(size)(props) + ";\n    " + lineHeight(height)(props) + "\n  ";
    };
};
var boxModel = function (prefix) { return function (top, right, bottom, left) {
    if (right === void 0) { right = top; }
    if (bottom === void 0) { bottom = top; }
    if (left === void 0) { left = right; }
    return function (props) {
        return Object.entries({ top: top, right: right, bottom: bottom, left: left })
            .map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return value !== null &&
                "" + (prefix && prefix + "-") + key + ": " + space(value)(props);
        })
            .filter(Boolean)
            .join(';');
    };
}; };
export var absolute = boxModel('');
export var padding = boxModel('padding');
export var margin = boxModel('margin');
export var border = function (value) { return function (props) { return props.theme.borders[value]; }; };
export var color = function (name, value) {
    if (value === void 0) { value = 0; }
    return function (props) {
        var result = props.theme.colors[name];
        if (typeof result === 'string') {
            return result;
        }
        else {
            return result && result[value] ? result[value] : name;
        }
    };
};
export var boxShadow = function (value) { return function (props) {
    return "box-shadow: " + props.theme.boxShadows[value];
}; };
export var space = function (value) { return function (props) {
    return typeof props.theme.space[value] !== 'undefined'
        ? props.theme.space[value] + "px"
        : value;
}; };
export var lineHeight = function (value) { return function (props) {
    return "line-height: " + space(value)(props);
}; };
export var maxWidth = function () { return function (props) { return "max-width: " + props.theme.maxWidth; }; };
export var minWidth = function () { return function (props) { return "min-width: " + props.theme.minWidth; }; };
export var modifiers = function (props) {
    if (!props.modifiers) {
        return '';
    }
    var styles = [];
    props.modifiers.forEach(function (modifier) {
        var _a = __read(modifier.split('.'), 2), key = _a[0], value = _a[1];
        switch (key) {
            case 'font-style':
            case 'font-weight':
                styles.push(key + ": " + value + " !important");
                break;
            case 'color':
                // eslint-disable-next-line no-case-declarations
                var colorName = value === 'brand' ? ['brand', 'normal'] : [value];
                styles.push(key + ": " + color.apply(void 0, __spread(colorName))(props) + " !important");
                break;
            default:
            // Nothing should happen
        }
    });
    return styles.join(';');
};
export var getForwardPropOpts = function (propsToFilter, respectValidity) {
    if (respectValidity === void 0) { respectValidity = true; }
    return ({
        shouldForwardProp: function (currentProp) {
            var isPropFound = propsToFilter.includes(currentProp);
            return respectValidity
                ? isPropValid(currentProp) && !isPropFound
                : !isPropFound;
        },
    });
};
export var textWithEllipsis = function (linesCount) {
    if (linesCount === void 0) { linesCount = 2; }
    return "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: " + linesCount + ";\n  -webkit-box-orient: vertical;\n";
};
